import React from 'react'

import { ErrorBoundary } from '@/shared/ui'
import { useNavigate } from 'react-router-dom'

export function ErrorBoundaryRedirect({ children }: React.PropsWithChildren) {
  const navigate = useNavigate()

  const onGoBackHandler = () => {
    void navigate('/')

    setTimeout(() => {
      window.location.reload()
    }, 300)
  }

  return <ErrorBoundary onGoBack={onGoBackHandler}>{children}</ErrorBoundary>
}
